import Popover from "@components/ui/popover";
import Spinner from "@components/ui/spinner";
import { cn } from "@lib/cn";
import { IconChevronDown } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useGetCurrentUserQuery, useGetFoldersQuery } from "@/shared/services";
import { CreateStoryFoldersList } from "./create-story-folders-list";

export const CreateStoryFolders = ({
  folder,
  setFolder,
}: {
  folder: { id: string; name: string };
  setFolder: (folder: { id: string; name: string }) => void;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { data: folders = [], isLoading: foldersLoading } =
    useGetFoldersQuery();
  const { isLoading: userLoading } = useGetCurrentUserQuery();
  const isLoading = foldersLoading || userLoading;
  const { folderId } = useParams<{ folderId?: string }>();

  useEffect(() => {
    if (folderId && !foldersLoading) {
      const folder = folders.find((f) => f._id === folderId);
      if (folder) setFolder({ id: folder._id, name: folder.name });
    }
  }, [folderId, foldersLoading, folders, setFolder]);

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <Popover.Trigger>
        <div
          className={cn(
            "tw-relative tw-flex tw-w-full tw-h-9 tw-cursor-pointer tw-items-center tw-justify-between tw-rounded-lg tw-border tw-border-solid tw-bg-white tw-px-3 tw-py-1 tw-font-sans tw-text-base tw-font-normal tw-leading-6 tw-text-blue",
            isOpen ? "tw-border-primary" : "tw-border-blue-100",
            !folder.name && "tw-text-blue-500",
          )}
        >
          <span className="tw-flex-1 tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap">
            {folder.name || "Select folder"}
          </span>
          <div className="tw-flex tw-shrink-0 tw-items-center">
            {isLoading ? (
              <Spinner />
            ) : (
              <IconChevronDown
                className={cn("tw-text-base tw-transition-transform", {
                  "tw-rotate-180": isOpen,
                })}
                style={{ color: "#88819F" }}
              />
            )}
          </div>
        </div>
      </Popover.Trigger>
      <Popover.Content className="tw-z-[10000] tw-w-[464px] tw-rounded-lg tw-border tw-border-solid tw-border-blue-100 tw-bg-white">
        <CreateStoryFoldersList
          setIsOpen={setIsOpen}
          folderId={folder.id}
          setFolder={setFolder}
        />
      </Popover.Content>
    </Popover>
  );
};
